import { twMerge } from 'tailwind-merge';
import { DeleteIcon, SearchIcon } from '@/icons';
import { classes, styles } from './utils';

export type AttachmentProps = {
  className?: string;
  src?: string;
  alt: string;
  onPreview: () => void;
  onDelete?: () => void;
};

export default function Attachment({
  className,
  src,
  alt,
  onPreview,
  onDelete,
}: AttachmentProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div
        style={styles.overlay}
        className={twMerge(classes.overlay, onDelete && classes.withDelete)}>
        <SearchIcon className={classes.icon} onClick={() => onPreview()} />
        {onDelete && (
          <DeleteIcon className={classes.icon} onClick={() => onDelete()} />
        )}
      </div>
      <img className={classes.img} src={src} alt={alt} />
    </div>
  );
}
